import type { GetApprovalByIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetApprovalByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetApprovalByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetApprovalByIdArgs = {
  id: string;
};

export const useGetApprovalById = createQueryHook<
  UseGetApprovalByIdArgs,
  GetApprovalByIdResponseRow[],
  GetApprovalByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.approval.approvalById.queryOptions({ id }),
  // tRPC returns 0 or 1 row; GraphQL `approval_by_pk` is a single nullable object.
  mapTrpcDataToGraphQL: (data) => ({ approval: data[0] ?? null }),
  graphqlDocument: GetApprovalByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
